const recursivePath = (data, parentPath = "")=> {
  let newData = [];  
  data.forEach((item, i) => {
    let copyItem = {};    
    Object.assign(copyItem, item) 
    let itemPath = `${parentPath}${item.path}`;
    copyItem.path = itemPath;    
    if (copyItem.childrens && typeof copyItem.childrens.length) {      
      copyItem.childrens = recursivePath([...copyItem.childrens], itemPath + "/");}   
    newData.push(copyItem);
  });
    return newData;
  }
  export default recursivePath;